import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
// import { Link, useNavigate } from 'react-router-dom'

import { Grid } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
// import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

import './style.css'
import { Model } from '../../../../models/model'
import { DialogConfirmDelete } from '../../../modals/confirmDelete/DialogConfirmDelete'
import { DialogFormEditTemplates } from './DialogFormEditTemplates'

export const Templates = ({ open, setOpen, createFrom }) => {

    const [templates, setTemplates] = useState([])
    const [idSelected, setIdSelected] = useState(0)
    const [openDialogConfirm, setOpenDialogConfirm] = useState(false)
    const [openTemplatesEdit, setOpenTemplatesEdit] = useState(false)
    const [currentTemplate, setCurrentTemplate] = useState([])

    useEffect(() => {
        handleGettemplates()
    }, [])

    const handleGettemplates = async () => {
        const results = await Model.getAll({
            url: 'tasks/templates/all'
        })
        // console.log({ results })
        setTemplates(results)
    }

    const createFromTemplate = async (templateId) => {
        const templateInfo = templates.find(it => it.id === templateId)
        const tasksList = JSON.parse(templateInfo.detalle_plantilla)
        console.log({ tasksList })
        await createFrom(tasksList)
    }

    const handleOpenConfirm = async (id) => {
        setIdSelected(id)
        setOpenDialogConfirm(true)
    }

    const handleDelete = async () => {
        await Model.delete({
            url: `tasks/templates/delete/${idSelected}`
        })

        handleGettemplates()
        setOpenDialogConfirm(false)
    }

    const handleOpenModify = async (selectTemplate) => {
        setCurrentTemplate(selectTemplate)
        setOpenTemplatesEdit(true)
    }

    const handleSaveChange = async (newTaskList) => {
        const templateId = currentTemplate.id

        const newPlantillaUpdated = JSON.stringify(newTaskList)
        const templatesUpdate = templates.map(template => {
            if (template.id === templateId) {
                return {
                    ...template,
                    detalle_plantilla: newPlantillaUpdated
                }
            }

            return template
        })

        setTemplates(templatesUpdate)

        const dataForm = {
            nombre: currentTemplate.nombre,
            detalle_plantilla: newPlantillaUpdated
        }

        await Model.update({
            url: `tasks/templates/${templateId}`,
            dataForm: dataForm,
            resultData: true
        })

    }

    return (
        <div>

            {openDialogConfirm &&
                <DialogConfirmDelete
                    open={openDialogConfirm}
                    setOpen={setOpenDialogConfirm}
                    params={{
                        text_title: null,
                        text_confirm: null,
                        button_name: null,
                        handleDelete
                    }}
                />
            }

            {openTemplatesEdit &&
                <DialogFormEditTemplates
                    open={openTemplatesEdit}
                    setOpen={setOpenTemplatesEdit}
                    templateInfo={currentTemplate}
                    handleSaveChange={handleSaveChange}
                />
            }

            <Dialog
                className='p-container-dialog-template'
                open={open}
                onClose={() => setOpen(false)}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle>
                    Seleccionar plantilla de tareas
                    <IconButton className='p-dialog-icon-close' aria-label="close" onClick={() => setOpen(false)}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers className='DialogContentVistaPrevia'>
                    <DialogBody
                        templates={templates}
                        createFromTemplate={createFromTemplate}
                        handleOpenConfirm={handleOpenConfirm}
                        handleOpenModify={handleOpenModify}
                    />
                </DialogContent>

            </Dialog>
        </div >
    );
}

const DialogBody = ({ templates, createFromTemplate, handleOpenConfirm, handleOpenModify }) => {
    // console.log({ templates })

    const { unitList } = useSelector(state => state.general)

    const handleChangeTemplate = async ({ target }, idTemplate) => {
        const { value: newIdUnidad } = target
        console.log({ newIdUnidad })

        await Model.update({
            url: `tasks/templates/unidad/${idTemplate}`,
            dataForm: {
                id: idTemplate,
                id_area_negocio: newIdUnidad
            }
        })

    }

    return (
        <Grid container spacing='20' columnSpacing='40' alignItems='center' direction='row'>
            {templates?.map(it => (
                <Grid item xs={12} sm={6} key={it.id}>
                    <div className='p-box-items-templates' style={{ height: '180px' }}>
                        <label title={it.nombre} style={{ textTransform: 'uppercase' }}>
                            {it.nombre.length > 50 ? `${it.nombre?.substring(0, 50)}...` : it.nombre}
                        </label>
                        <div className='d-flex justify-content-between align-items-center mt-2' style={{ width: '100%' }}>
                            <Button
                                title="usar esta plantilla"
                                type='button'
                                className='btn btn-sm p-btn-primary-small'
                                style={{ height: '50px' }}
                                onClick={() => createFromTemplate(it.id)}
                            >
                                Usar
                            </Button>
                            <Button
                                title="modificar plantilla"
                                type='button'
                                className='btn btn-sm p-btn-primary-small-nobg ms-2'
                                onClick={() => handleOpenModify(it)}
                            >
                                Modificar
                            </Button>
                            <i
                                className="bi bi-trash ms-5 p-trash"
                                onClick={() => handleOpenConfirm(it.id)}
                                title="eliminar plantilla"></i>
                        </div>
                        <div className='mt-3 d-flex flex-column justify-content-start align-items-start'>
                            <span>Plantilla para:</span>
                            <select
                                style={{
                                    border: '1px solid lightgray',
                                    padding: '3px',
                                    borderRadius: '3px',
                                    textTransform: 'capitalize'
                                }}
                                name="id_area_negocio"
                                onChange={(e) => handleChangeTemplate(e, it.id)}
                            >
                                <option key="" value="" selected>--seleccionar--</option>
                                {unitList.map(un => {
                                    if (parseInt(un.id) === parseInt(it.id_area_negocio)) {
                                        return <option key={un.id} value={un.id} selected>{un.nombre}</option>
                                    } else {
                                        return <option key={un.id} value={un.id}>{un.nombre}</option>
                                    }
                                })}
                            </select>
                        </div>
                    </div>
                </Grid>
            ))}
        </Grid>
    )
}